module.exports = __webpack_public_path__ + "img/header_new3.6521bfbb.jpg";